module.exports = require("randombytes");